import * as angular from 'angular';

import { ComponentDefinition, Group, TagStringValueDto } from '../../../models';
import { IPrintConfiguration } from '../../../services/helpers';
import { HeaderInfo } from '../HeaderInfo';
import { ScaledPage } from '../ScaledPage';
import { PartialStore } from '../scaledPrintPreviewState.component';
import { IWidget } from '../../../widgets';
import { getWidgetClass } from '../../../common/helpers/getWidgetClass';

class ScaledPageController implements angular.IComponentController {
    isLoaded: boolean;

    readonly headerInfo: HeaderInfo;
    readonly page: ScaledPage;
    readonly partialStore: PartialStore;
    readonly printConfig: IPrintConfiguration;
    readonly selectedGroup: Group;
    readonly stringValues: TagStringValueDto[];

    static $inject = [];

    constructor() {
        this.isLoaded = true;
    }

    getWidgetClass(item: IWidget) {
        const result = getWidgetClass(item);
        result['hidden-border'] = !!this.printConfig.isHidingBorder;
        return result;
    }
}

export const wtScaledPage: ComponentDefinition = {
    componentId: 'wtScaledPage',
    controller: ScaledPageController,
    template: require('./scaledPage.component.html'),
    controllerAs: 'vm',
    bindings: {
        headerInfo: '<',
        page: '<',
        partialStore: '<',
        printConfig: '<',
        selectedGroup: '<?',
        stringValues: '<'
    }
};